import React from 'react';
import ReactDOM from 'react-dom/client';

import { Auth0Provider } from '@auth0/auth0-react';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-db3dztjhdm66nisi.us.auth0.com" // zmienne
      clientId="lXjocEnaLhx4K48Ne8InNq2o8TLtHLhF"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://dev-db3dztjhdm66nisi.us.auth0.com/api/v2/",
        scope: "read:current_user"
      }}
      cacheLocation="localstorage"
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
